import {
  Component,
  Input,
  OnInit,
  SimpleChanges,
  OnChanges,
  OnDestroy,
  ChangeDetectionStrategy,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { EmailService } from './email.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ANIMATION_MODULE_TYPE } from '@angular/platform-browser/animations';
import { Subject, takeUntil } from 'rxjs';

export interface EmailData {
  FromAddress: string;
  FromAddressName: string;
  ToAddress: string;
  CCAddress: string;
  BCCAddress: string;
  Subject: string;
  MessageBody: string;
  IsBodyHtml: boolean;
}

@Component({
  selector: 'send-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.scss'],
  providers: [{ provide: ANIMATION_MODULE_TYPE, useValue: 'BrowserAnimations' }],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class EmailComponent implements OnInit, OnChanges, OnDestroy {
  @Input() email: any;

  emailForm: UntypedFormGroup;
  ccBCC = true;
  isBodyHtml = true;
  row = 5;
  loading: any = false;

  private _destroyed$ = new Subject<void>();

  constructor(
    private _snackBar: MatSnackBar,
    private _fb: UntypedFormBuilder,
    private _emailService: EmailService,
  ) {}

  ngOnInit() {
    //  this._emailBindings()
    // Subscribe to the Form Changes. Listen to User Changes.
    this.emailForm.valueChanges.pipe(takeUntil(this._destroyed$)).subscribe((value) => {});
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.email) {
      console.log('email data');
      console.log(`${JSON.stringify(this.email)}`);
      this.email = changes.email.currentValue;
      this._emailBindings();
    }
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  private _emailBindings() {
    if (this.ccBCC == true) {
      this.emailForm = this._fb.group({
        FromAddressName: this.email.FromAddressName,
        FromAddress: this.email.FromAddress,
        ToAddress: [
          this.email.ToAddress,
          [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,3}$')],
        ],
        CCAddress: this.email.CCAddress,
        BCCAddress: this.email.BCCAddress,
        Subject: [this.email.Subject, Validators.required],
        MessageBody: [this.email.MessageBody, Validators.required],
        IsBodyHtml: this.email.IsBodyHtml,
      });
    } else {
      this.emailForm = this._fb.group({
        FromAddressName: this.email.FromAddressName,
        FromAddress: this.email.FromAddress,
        ToAddress: [
          this.email.ToAddress,
          [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,3}$')],
        ],
        Subject: [this.email.Subject, Validators.required],
        MessageBody: [this.email.MessageBody, Validators.required],
        IsBodyHtml: this.email.IsBodyHtml,
      });
    }
  }

  validSendEmail(data) {
    const email = data.value;
    this._emailService.SendEmail(email).subscribe((response) => {
      if (response.message === 'Success') {
        this.openSnackBar(response.data.msg, 'ok');
      }
    });
  }

  //      ---------------------------------------------------------------------------
  //      -------------------------USER EXPERIENCE-----------------------------------
  //      ---------------------------------------------------------------------------

  // snackbar alert
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 5000,
      verticalPosition: 'top',
    });
  }
}
